import { render } from "./CapsuleToyNOTicket.vue?vue&type=template&id=0d703784&scoped=true"
import script from "./CapsuleToyNOTicket.vue?vue&type=script&lang=js"
export * from "./CapsuleToyNOTicket.vue?vue&type=script&lang=js"

import "./CapsuleToyNOTicket.vue?vue&type=style&index=0&id=0d703784&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d703784"]])

export default __exports__